import { Col, Form, Modal, Row, Spin, Table, message } from "antd";
import COLORS from "common/Colors";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import React, { useEffect, useState } from "react";
import { useUpdate } from "hooks/useUpdate";
import { ButtonFilled } from "reusableComponent/UIButtons";
import styled from "styled-components";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import { CALL_AI_API, CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import moment from "moment";
import { EditChargeOut } from "./EditChargeOut";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { connect, useSelector } from "react-redux";
import { getClientid, getCountryCodeOptions, getGradeList, getMenuList, getUserRoleId } from "redux/selectors";
import { setUserList } from "redux/actions";
import { bindActionCreators } from "redux";

const StyledModal = styled(Modal)`
  .ant-form-item {
    margin-bottom: "12px";
  }
`;

const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledhistoryTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table {
    max-height: 350px;
    overflow-y: auto;
  }
  .ant-table-content {
    overflow-x: auto;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
`;

function ChargeoutRates({ updateUserList, ClientId, menuList, userRoleId }) {
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
  const canEditChargeout = Menulist?.find(
    (item) =>
      item?.key === "manage" &&
      item?.subMenu.find(
        (subItem) =>
          subItem?.key === "chargeout-rates" && subItem?.permission.edit
      )
  );
  const [isEdit, setIsEdit] = useState(false);
  const [isHistory, setIsHistory] = useState(false);
  const [recordValue, setRecordValue] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setRecordValue({});
  }, []);

  const fetchMasterData = async (fetch_master_data) => {
    const { code, userList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      {
        fetch_master_data,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      updateUserList(userList);
    }
  };

  const { key, url } = queryKeys.getChargeoutRates;
  const { key: historyKey, url: historyUrl } =
    queryKeys.getHistoryChargeoutRates(recordValue?.chargeoutid);
  const { data, isLoading, refetch } = useFetch(key, url);

  const { data: historyData, isLoading: isLoadingHistory } = useFetch(
    historyKey,
    historyUrl,
    {
      enabled: isHistory,
    }
  );

  let historyDataSource = historyData?.response?.items?.filter(
    (val) => val?.countrycode === recordValue?.country
  );

  const updateChargeoutRate = async (id, payload) => {
    try {
      setLoading(true);
      const response = await CALL_API(
        `settings/chargeout/${id}`,
        "patch",
        payload
      );

      if (response.code === STATUS_CODE.SUCCESS) {
        message.success("Successfully Updated");
        setLoading(false);
        setIsEdit(false);
        refetch();
        fetchMasterData(true);
      } else {
        message.error(
          `Update failed: ${response.message || "please try again."}`
        );
        setLoading(false);
        setIsEdit(false);
      }
    } catch (error) {
      message.error("An error occurred: " + error.message);
    } finally {
    }
  };

  const handleFormSubmit = (values) => {
    const id = recordValue.chargeoutid;
    const isTitleEdited = values.jobgrade !== recordValue.jobgrade;
    let payload = {
      [recordValue.country]: values.rate,
      designation: recordValue.designation,
      exception: recordValue.exception,
      jobgrade: values.jobgrade,
      jobgradecode: values.jobgradecode,
      revenueKPI: recordValue.revenueKPI,
      standard: values.standard,
      targetchargeability: values.targetchargeability,
      typeofwork: recordValue.typeofwork,
      rate: values.rate,
      countrycode: recordValue.country,
      edittitle: isTitleEdited ? true : false,
    };
    updateChargeoutRate(id, payload);
  };

  const historyColumns = [
    {
      title: "Job Grade Code",
      dataIndex: "jobgradecode",
      key: "jobgradecode",
      align: "center",
      render: (text) => {
        return text || "-";
      },
    },
    {
      title: "Target Chargeability",
      dataIndex: "targetchargeability",
      key: "targetchargeability",
      align: "center",
      render: (text) => (text ? `${text}%` : "-"),
    },
    // {
    //   title: "Exception",
    //   dataIndex: "Exception",
    //   key: "Exception",
    //   align: "center",
    //   render:(text)=>{
    //     return text || "-"
    //   }
    // },
    {
      title: "Standard",
      dataIndex: "standard",
      key: "standard",
      align: "center",
      render: (text) => (text ? `$${text}` : "-"),
    },
    {
      title: "Rate",
      dataIndex: "rate",
      key: "rate",
      align: "center",
      render: (text) => (text ? `$${text}` : "-"),
    },
    // {
    //   title: "DRC",
    //   dataIndex: "KE",
    //   KEy: "ke",
    //   align: "center",
    //    render: (text) =>  text ? `$${text}` : "-"
    // },
    // {
    //   title: "KE",
    //   dataIndex: "KE",
    //   KEy: "ke",
    //   align: "center",
    //    render: (text) =>  text ? `$${text}` : "-"
    // },
    // {
    //   title: "UG",
    //   dataIndex: "KE",
    //   key: "KE",
    //   align: "center",
    //    render: (text) =>  text ? `$${text}` : "-"
    // },
    // {
    //   title: "RW",
    //   dataIndex: "RW",
    //   key: "RW",
    //   align: "center",
    //    render: (text) =>  text ? `$${text}` : "-"
    // },
    // {
    //   title: "ET",
    //   dataIndex: "ET",
    //   key: "ET",
    //   align: "center",
    //    render: (text) =>  text ? `$${text}` : "-"
    // },
    // {
    //   title: "TZ",
    //   dataIndex: "TZ",
    //   key: "TZ",
    //   align: "center",
    //    render: (text) =>  text ? `$${text}` : "-"
    // },
    // {
    //   title: "Type of Work",
    //   dataIndex: "type_of_work",
    //   key: "Typeofwork",
    //   width: "20%",
    //   align: "center",
    //   render:(text)=>{
    //     return text || "-"
    //   }
    // },
    {
      title: "Updated At",
      dataIndex: "updatedat",
      key: "updatedat",
      render: (updatedat) => moment(updatedat).format("DD-MM-YYYY") || "-",
    },
  ];

  const columns = [
    {
      title: "Job Grade Code",
      dataIndex: "jobgradecode",
      key: "jobgradecode",
    },
    {
      title: "Job Grade Title",
      dataIndex: "jobgrade",
      key: "jobgrade",
      align: "center",
      render: (text) => {
        return text || "-";
      },
    },
     {
      title: "Charge Out Rate",
      dataIndex: "rate",
      key: "rate",
      render: (text) => (text ? `$ ${text}` : "-"),
    },
    {
      title: "Target Chargeability",
      dataIndex: "targetchargeability",
      key: "targetchargeability",
      render: (text) => (text ? `${text}%` : "-"),
    },
    {
      title: "Standard",
      dataIndex: "standard",
      key: "standard",
      render: (text) => (text ? `$ ${text}` : "-"),
    },
    {
      title: "Country Code",
      dataIndex: "country",
      key: "country",
    },
    // {
    //   title: "Type of Work",
    //   dataIndex: "type_of_work",
    //   key: "Typeofwork",
    //   width: "20%",
    //   align: "center",
    //   render:(text)=>{
    //     return text || "-"
    //   }
    // },
    {
      title: "Action",
      dataIndex: "type_of_work",
      key: "type_of_work",
      align: "center",
      render: (_, record) => (
        <div className="d-flex">
          {canEditChargeout && (
            <ButtonFilled
              onClick={() => {
                setIsEdit(true);
                setRecordValue(record);
              }}
            >
              Edit
            </ButtonFilled>
          )}
          <ButtonFilled
            onClick={() => {
              setIsHistory(true);
              setRecordValue(record);
            }}
          >
            History
          </ButtonFilled>
        </div>
      ),
    },
  ];

  const customLocale = {
    emptyText: <div>"No history data"</div>,
  };

  const [form] = Form.useForm();

  const countries = useSelector(getCountryCodeOptions);
  const gradeListData = useSelector(getGradeList) || [];
  const Grade = gradeListData.map((item) => item.jobgradecode);

  const allResponseData = data?.response?.items
    .flatMap((item, index) =>
      countries.map((country) => ({
        jobgradecode: item.jobgradecode,
        targetchargeability: item.targetchargeability,
        standard: item.standard,
        country: country.code,
        countryName: country.country,
        rate: item[country.code],
        typeofwork: item.typeofwork,
        designation: item.designation,
        exception: item.exception,
        jobgrade: item.jobgrade,
        revenueKPI: item.revenueKPI,
        chargeoutid: item?.id,
      }))
    )
    ?.sort((a, b) => {
      if (a.countryName < b.countryName) return -1;
      if (a.countryName > b.countryName) return 1;

      const gradeA = Grade.indexOf(a.jobgradecode);
      const gradeB = Grade.indexOf(b.jobgradecode);

      return (
        (gradeA === -1 ? Number.MAX_SAFE_INTEGER : gradeA) -
        (gradeB === -1 ? Number.MAX_SAFE_INTEGER : gradeB)
      );
    });

  const allData = allResponseData
    ? allResponseData?.map((item, index) => ({
        ...item,
        id: index + 1,
      }))
    : [];

  useEffect(() => {
    setFilteredData(getFilteredData());
  }, [data]);

  const [filteredData, setFilteredData] = useState(allData);

  const headerstyle = { fontSize: "20px", fontWeight: "bold" };

  const getFilteredData = () => {
    const values = form.getFieldsValue();
    const grade = values.grade || [];
    const country = values.country || [];

    if (grade.length === 0 && country.length === 0) return allData;

    return allData.filter(
      (item) =>
        (grade.length === 0 || grade.includes(item.jobgradecode)) &&
        (country.length === 0 || country.includes(item.country))
    );
  };

  const gradeOptions = Grade?.map((item) => ({
    label: item,
    value: item,
  }));

  const countryOptions = countries.map((item) => ({
    label: item.country,
    value: item.code,
  }));

  return (
    <>
      <Row className="page-title">
        <Col sm={24} md={12} style={headerstyle}>
          List of Chargeout Grade
        </Col>
      </Row>

      <Form
        form={form}
        layout="vertical"
        className="mt-2"
        onValuesChange={() => setFilteredData(getFilteredData())}
      >
        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <DropdownCheckBox
              name="grade"
              label="Grade"
              options={gradeOptions}
              form={form}
              handleFormChange={() => {
                form.setFieldsValue({ grade: [] });
                setFilteredData(getFilteredData());
              }}
            />
          </Col>

          <Col xs={24} sm={8}>
            <DropdownCheckBox
              name="country"
              label="Country"
              options={countryOptions}
              form={form}
              handleFormChange={() => {
                form.setFieldsValue({ country: [] });
                setFilteredData(getFilteredData());
              }}
            />
          </Col>
        </Row>
      </Form>

      <Spin spinning={isLoading}>
        <StyledTable
          dataSource={filteredData}
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="id"
          pagination={false}
        />
      </Spin>
      {/* <StyledModal
        title="Edit Chargeout Rates"
        width={900}
        open={isEdit}
        footer={false}
        onCancel={()=>{setIsEdit(false);setRecordValue({})}}
      >
        <GridBuilder formStructureJson={ChargeoutFormJson} initialValues={recordValue} formSubmit={handleFormSubmit} loading={loading} isModalOpen={isEdit}/>
      </StyledModal> */}
      <EditChargeOut
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        setRecordValue={setRecordValue}
        loading={loading}
        recordValue={recordValue}
        handleFormSubmit={handleFormSubmit}
        isLoading={isLoading}
      />
      <StyledModal
        title="Chargeout Rates History"
        width={900}
        open={isHistory}
        footer={false}
        onCancel={() => setIsHistory(false)}
      >
        <Spin spinning={isLoadingHistory}>
          <StyledhistoryTable
            columns={historyColumns}
            dataSource={historyDataSource?.length > 0 ? historyDataSource : []}
            rowClassName={(record, index) =>
              index % 2 === 0 ? "" : "non-white"
            }
            rowKey={(record) => record.key}
            pagination={false}
            locale={customLocale}
          />
        </Spin>
      </StyledModal>
    </>
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateUserList: setUserList,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  ClientId: getClientid(state),
  menuList: getMenuList(state),
  userRoleId: getUserRoleId(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null
)(ChargeoutRates);
